export default class StringUtils {
    static joinWithCommaAndAnd(strings) {
        if (strings.length === 0) {
            return "";
        }
        if (strings.length === 1) {
            return strings[0];
        }
        const lastItem = strings[strings.length - 1];
        const others = strings.slice(0, strings.length - 1);
        return `${others.join(", ")}, and ${lastItem}`;
    }
    static escapeRegex(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    static truncate(string, limit) {
        return this.patternTruncate(string, limit, "...");
    }
    static patternTruncate(string, limit, ending) {
        if (limit < 1) {
            return "";
        }
        // If the string is already appropriately sized, return it
        if (!string || string.length <= limit) {
            return string;
        }
        // remove ending if it is too long
        if (!ending || ending.length > limit) {
            ending = "";
        }
        const limitMinusEnding = limit - ending.length;
        const limitedFullString = string.substring(0, limitMinusEnding);
        return limitedFullString + ending;
    }
    static normalizePhoneNumber(phoneNumber) {
        return phoneNumber.replace(/\D/g, "");
    }
    static formatPhoneNumber(phoneNumber) {
        // Ensure the string is exactly 10 digits long
        if (phoneNumber.length !== 10 || /\D/.test(phoneNumber)) {
            throw new Error("Input must be a string of 10 digits.");
        }
        // Format the string into the (xxx) xxx-xxxx format
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    }
}
